<template>
  <div class="editBG pt-3 mt-4">
    <v-dialog v-model="dialogImage" width="400px">
      <v-card>
        <v-img v-if="dialogJpg" :src="`/static/${dialogJpg}.jpg`"></v-img>
        <!-- aspect-ratio="2.75" -->
        <!-- <v-card-title>
          <span class="headline">Use Google's location service?</span>
        </v-card-title> -->
        <!-- <v-card-text>

        </v-card-text> -->
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="dialogImage = false">Disagree</v-btn>
          <v-btn color="green darken-1" flat="flat" @click="dialog = false">Agree</v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>

    <v-navigation-drawer
      width="420"
      temporary
      absolute
      right
      v-model="options_c"
      dark
      style="margin-top: 8px"
      class="px-2 navbar"
      hide-overlay
    >
      <h1 class="pl-3 pt-3 pb-2 font-weight-regular display-1 white--text">
        Options
      </h1>

      <v-divider class="mx-3 pb-0 mb-0 white"></v-divider>

      <!-- <v-layout row pt-0 mt-0>
        <v-flex >
          <v-subheader class="white--text">
            Editing User
            <v-spacer></v-spacer>
          </v-subheader>
        </v-flex>
      </v-layout>-->

      <v-list>
        <!-- 'Settings',  -->
        <v-list-tile
          class="pl-0 ml-4 ml-0 pl-0"
          v-for="tab in ['Details', 'History']"
          :key="tab"
          @click="setCurrentTab(tab)"
        >
          <v-list-tile-content>
            <v-list-tile-title>{{ tab }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-divider class="mx-3 pb-0 mb-0 white"></v-divider>
      <!-- <v-layout row pt-0 mt-0>
        <v-flex >
          <v-subheader class="white--text">
            Export PDF for:
            <v-spacer></v-spacer>
            <a @click="">Export</a>
          </v-subheader>
        </v-flex>
      </v-layout>-->

      <!-- <v-list>
        <v-list-tile class="pl-0 ml-4" @click="setCurrentTab('details')">
          <v-list-tile-content>
            <v-list-tile-title>User Details </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="pl-0 ml-4" @click="setCurrentTab('settings')">
          <v-list-tile-content>
            <v-list-tile-title>User rights  </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="pl-0 ml-4" @click="setCurrentTab('history')">
          <v-list-tile-content>
            <v-list-tile-title>User History </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>-->
    </v-navigation-drawer>

    <v-layout
      row
      wrap
      style="
        background-color: white;
        height: 30px;
        width: 100%;
        top: 135px;
        position: fixed;
        z-index: 1;
        height: 50px;
      "
    >
      <v-flex xs12> </v-flex>
    </v-layout>

    <v-toolbar
      tabs
      color="white"
      class="elevation-1 mt-2"
      style="top: 155px; position: fixed; z-index: 1"
    >
      <h4 class="pl-3 headline font-weight-light">
        {{ userFormData.firstname }} {{ userFormData.lastname }}
        <span v-if="userFormData.enable == 'N'" class="pl-3 red--text">
          – DISABLED</span
        >
      </h4>
      <v-spacer></v-spacer>
      <v-btn
        v-if="c_user.delete_rights"
        small
        icon
        class="mr-3"
        @click="$router.go(-1)"
        right
      >
        <v-icon small color="red">delete</v-icon>
      </v-btn>
      <v-btn small icon class="mr-3" @click="$router.go(-1)" right>
        <v-icon small>close</v-icon>
      </v-btn>
      <v-btn icon small :disabled="!valid" @click="save" right>
        <v-icon small>save</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card class="editBG elevation-0">
      <v-layout
        class="row wrap xs12 ml-3 mr-4 pl-1 mt-4 pt-5 pr-4"
        style="top: 155px; z-index: 1"
      >
        <!-- <v-flex class="pl-2 xs12 mb-3">
          <v-btn class="right mr-2 pr-0" icon :loading="loading" @click="save">
            <v-icon>save</v-icon>
          </v-btn>
          <v-subheader class="font-weight-regular display-1 black--text xs12">
            {{ userFormData.firstname }} {{ userFormData.lastname }}
            <span v-if="userFormData.enable == 'N'" class="pl-3 red--text">
              – DISABLED</span
            >
            <v-spacer></v-spacer>
            <v-btn
              class="right mr-2 pr-0"
              icon
              @click="
                options = false;
                $router.go(-1);
              "
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-subheader>
        </v-flex> -->

        <v-flex class="pl-5 py-0 xs12 md5 mb-0 mt-2">
          <v-avatar size="136px" color="white">
            <!-- <v-img src="http://www.tb-cms.org/simone3.jpg"></v-img> -->
            <!-- <img
              v-if="message.avatar"
              src="https://avatars0.githubusercontent.com/u/9064066?v=4&s=460"
              alt="Avatar"
            >-->
            <v-icon size="116px" color="black">person</v-icon>
          </v-avatar>
        </v-flex>

        <v-flex class="pl-3 xs12 md7 mb-0 mt-3">
          <v-layout row wrap xs12 class="">
            <v-flex xs6 pl-2 pb-4 class="bleft">
              <b>Login:</b>
            </v-flex>
            <v-flex xs6 pl-2 class="bleft">
              <b>{{ userFormData.login }}</b>
            </v-flex>

            <v-flex xs6 pl-2 pb-2 class="bleft">Account Created on:</v-flex>
            <v-flex xs6 pl-2 class="bleft">{{
              formatDate(userFormData.created_at)
            }}</v-flex>

            <v-flex xs6 pl-2 pb-2 class="bleft">Last Update:</v-flex>
            <v-flex xs6 pl-2 class="bleft">{{
              formatDate(userFormData.updated_at)
            }}</v-flex>

            <v-flex xs6 pl-2 class="bleft">Account Abbreviation:</v-flex>
            <v-flex xs6 pl-2 class="bleft">{{ userFormData.abb }}</v-flex>
          </v-layout>
        </v-flex>
        <!-- <v-divider class="mx-3 pb-0 mb-0 black"></v-divider> -->
      </v-layout>
    </v-card>
    <!-- </v-form> -->

    <!-- <v-layout mx-0 pl-4 ml-3 mt-0 pt-4>
      <v-flex class="xs12 ">
        <v-flex class=" pb-0 mb-0 xs8 ">
          <h4 class="headline font-weight-bold py-0 my-0">{{userFormData.firstname}} {{userFormData.lastname}} <span v-if="userFormData.enable=='N'" class="red--text">DISABLED</span></h4>
        </v-flex>
        <v-flex class="xs12 ">
          <h4 class="headline py-0 my-0 "><span :class="{'red--text': userFormData.active}">{{userFormData.login}} </span></h4>
        </v-flex>
      </v-flex>
      <v-spacer></v-spacer>
      <a class="headline mr-5 black--text" @click="options=false;$router.go(-1)">close</a>
    </v-layout>-->

    <!-- <v-menu bottom right>
        <v-btn slot="activator" icon>
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="addToSelection(userFormData.id)">
            <v-list-tile-title>Add this artwork to list</v-list-tile-title>
          </v-list-tile>
          <pdf-eh :artwork="userFormData"></pdf-eh>
        </v-list>
    </v-menu>-->
    <!-- <v-btn icon><v-icon>more_vert</v-icon></v-btn> -->
    <!-- <v-tabs slot="extension" color="transparent" slider-color="purple" align-with-title v-model="currentTab" show-arrows> -->
    <!-- <v-tab v-for="tab in fields.tabs" :ripple="false"
          :key="tab.key"
          :href="'#tab-' + tab.key" 
          @click="saveCurrentTab('tab-' + tab.key)"
          v-if="tab.work_types && tab.work_types.includes(userFormData.classification)"
        >
    {{ tab.title }}-->
    <!-- </v-tab> -->
    <!-- </v-tabs> -->
    <!-- </v-toolbar> -->
    <!-- {{this.fields.tabs}} -->

    <!-- <v-layout mx-0 pl-0 ml-3 mt-0 pt-4> -->

    <!-- <v-flex v-for="tab in ['details','settings','history']"
        :key="tab" 
        :id="'tab-' + tab.key"
        class="grey lighten-2 elevation-0"
    >-->
    <!-- <div> -->
    <v-form id="form" ref="form" v-model="valid" lazy-validation>
      <v-card class="editBG px-3 pt-0 elevation-0 pb-4" style>
        <v-container grid-list-xs fluid>
          <v-layout row wrap v-if="currentTab == 'Details'">
            <v-flex
              style="background-color: #292929; color: #eee"
              class="px-3 py-1 my-2 elevation-0 xs12"
            >
              <h3 class="font-weight-bold subtitle xs12 flex">Basic</h3>
            </v-flex>

            <v-flex xs12 sm6 pl-3 my-2>
              <v-text-field
                browser-autocomplete="off"
                v-model="userFormData.firstname"
                label="First Name"
                color="black"
                class="black--text dark"
                hide-details
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 pl-3 my-2>
              <v-text-field
                browser-autocomplete="off"
                v-model="userFormData.lastname"
                label="Last Name"
                color="black"
                class="black--text dark"
                hide-details
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 pl-3 mt-2>
              <v-text-field
                browser-autocomplete="off"
                v-model="userFormData.abb"
                label="Shortcut"
                color="black"
                class="black--text dark"
                hint="Shows in tables and at places wher full name of user doesn't fit"
              ></v-text-field>
            </v-flex>

            <v-flex
              v-if="userFormData.id == c_user.id"
              style="background-color: #292929; color: #eee"
              class="px-2 py-1 mt-3 mb-2 elevation-0 xs12"
            >
              <h3 class="font-weight-bold subtitle xs12 flex">Login</h3>
            </v-flex>

            <v-flex xs12 sm6 pl-3 v-if="userFormData.id == c_user.id">
              <v-text-field
                v-model="userFormData.login"
                browser-autocomplete="off"
                label="Login"
                color="black"
                class="black--text dark"
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm6
              pl-3
              v-if="
                userFormData.id == c_user.id ||
                c_user.admin == 1 ||
                (c_user.roles &&
                  c_user.roles.find((f) => f.shortcut == 'edit_password'))
              "
            >
              <v-text-field
                browser-autocomplete="off"
                v-model="userFormData.password"
                label="Password (fill in only if you want to change it)"
                :type="show3 ? 'password' : 'text'"
                color="black"
                placeholder="*********"
                class="black--text dark"
                :append-icon="show3 ? 'visibility' : 'visibility_off'"
                @click:append="show3 = !show3"
              ></v-text-field>
            </v-flex>

            <v-flex
              style="background-color: #292929; color: #eee"
              class="px-3 py-1 mt-3 mb-3 elevation-0 xs12"
            >
              <h3 class="font-weight-bold subtitle xs12 flex">Contact</h3>
            </v-flex>
            <v-flex xs12 sm6 pl-3>
              <v-text-field
                browser-autocomplete="off"
                v-model="userFormData.email"
                label="E-mail"
                color="black"
                class="black--text dark"
                hide-details
              ></v-text-field>
            </v-flex>

            <v-flex
              style="background-color: #292929; color: #eee"
              class="px-3 py-1 mt-4 elevation-0 xs12"
              v-if="c_user.edit"
            >
              <h3 class="font-weight-bold subtitle xs12 flex">User Rights</h3>
            </v-flex>

            <!-- <v-flex xs12 pl-3 my-2 v-if="c_user.edit">
              <v-autocomplete
                :items="formatted_roles"
                v-model="userFormData.roles"
                item-text="title"
                item-value="id"
                chips
                multiple
                filled
                deletable-chips
                label="Choose user roles"
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    :color="`${data.item.color} lighten-4`"
                    close
                    @input="remove(data.item.id)"
                    >{{ data.item.title }}</v-chip
                  >
                </template>

                <template v-slot:item="data">
                  <template
                    v-if="typeof data.item !== 'object'"
                    :class="`${data.item.color} lighten-4 full-width my-2`"
                  >
                    {{ data.item.selected }}test
                    <div
                      :class="
                        `${data.item.color} lighten-4 px-3 full-width my-2`
                      "
                      v-text="data.item"
                    ></div>
                  </template>

                  <template v-else>
                    <div
                      :class="`${data.item.color} lighten-4 full-width my-2`"
                    >
                      {{ data.attrs }}
                      <div
                        :class="
                          `${data.item.color} lighten-4 full-width px-3 my-2`
                        "
                        v-html="data.item.title"
                      ></div>
                    </div>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex> -->

            <v-flex xs12 px-0>
              <v-container fluid pa-0 ma-0 grid-list-xs text-xs-left>
                <v-layout row wrap pa-0 ma-0 class="grey lighten-2 pb-4">
                  <v-flex
                    v-for="r in formatted_roles"
                    :key="r.id"
                    :class="{
                      xs12: r.header || r.divider,
                      'xs12 sm6 md4 lg3': !(r.header || r.divider),
                      'px-2 py-0 my-0': true,
                    }"
                  >
                    <!-- <v-container fluid pa-0 ma-0>
                      <v-layout row wrap pa-0 ma-0> -->
                    <v-flex
                      xs12
                      pt-3
                      pl-3
                      pb-0
                      mb-0
                      mt-4
                      v-if="r.header || r.divider"
                    >
                      <h2>
                        <span>{{ r.header }}</span>
                        <!-- <v-spacer></v-spacer> -->
                        <v-btn
                          v-if="r.image"
                          @click="showHelp(r.image)"
                          class="right mt-0 pt-0 pb-2"
                          icon
                        >
                          <v-icon color="grey darken-1">help</v-icon>
                        </v-btn>
                      </h2>
                      <v-divider class="py-0 my-0"></v-divider>
                    </v-flex>
                    <v-flex xs12 py-0 pt-0 my-0 pl-3 v-else>
                      <!-- :disabled="roles_array.includes(2) && [1,17,18,19,20,21,22,31,32,40,41].includes(r.id)" -->
                      <v-checkbox
                        @change="remove(r.id)"
                        v-model="roles_array"
                        :color="r.color"
                        :label="r.title"
                        :value="r.id"
                        hide-details
                      ></v-checkbox>
                    </v-flex>
                    <!-- </v-layout>
                    </v-container> -->
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>

            <!-- <v-layout row wrap v-if="currentTab == 'Settings'" pl-0> -->
            <v-flex
              v-if="c_user.edit"
              style="background-color: #292929; color: #eee"
              class="px-3 py-1 my-2 elevation-0 xs12"
            >
              <h3 class="font-weight-bold subtitle xs12 flex">
                New User Rights
              </h3>
            </v-flex>

            <v-flex xs12 sm6 pl-3 v-if="c_user.edit">
              <v-checkbox
                v-model="userFormData.edit"
                :label="
                  userFormData.edit ? 'Can Edit data' : 'Can\'t Edit data'
                "
                color="red"
                class="black--text dark"
                hide-details
              ></v-checkbox>
            </v-flex>
            <!-- <v-flex xs12 sm6 md4 pl-3>
              <v-checkbox v-model="userFormData.reports" label="Reports" color="black" hide-details></v-checkbox>
            </v-flex>-->
            <v-flex xs12 sm6 v-if="c_user.edit">
              <v-checkbox
                v-model="userFormData.delete_rights"
                :label="
                  userFormData.delete_rights
                    ? 'Can Delete data'
                    : 'Can\'t Delete Data'
                "
                false-value="0"
                true-value="1"
                color="red"
                hide-details
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 sm6 pl-3 v-if="c_user.edit">
              <v-checkbox
                v-model="userFormData.admin"
                :label="
                  userFormData.admin
                    ? 'Is Admin (Full access to all features)'
                    : 'Isn\'t Admin (Full access to all features)'
                "
                color="red"
                hide-details
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 sm6 v-if="c_user.edit">
              <v-checkbox
                v-model="userFormData.enable"
                :label="userFormData.enable ? 'User Enabled' : 'User Disabled'"
                false-value="N"
                true-value="Y"
                color="red"
                hide-details
              ></v-checkbox>
            </v-flex>

            <v-flex
              style="background-color: #292929; color: #eee"
              class="px-3 py-1 my-2 mt-4 elevation-0 xs12"
            >
              <h3 class="font-weight-bold subtitle xs12 flex">
                Notifications Settings
              </h3>
            </v-flex>
            <!-- <v-form v-model="valid" ref="form" lazy-validation> -->

            <!-- <v-card color="grey lighten-4" flat>
                <v-card-text>
                  <v-container fluid>
            <v-layout row wrap>-->
            <v-flex xs6 pl-3>
              <v-checkbox
                label="New artwork added"
                v-model="userFormData.new_artwork_added"
                color="black"
                hide-details
              ></v-checkbox>
            </v-flex>
            <v-flex xs6>
              <v-checkbox
                label="New artist added"
                v-model="userFormData.new_artist_added"
                color="black"
                hide-details
              ></v-checkbox>
            </v-flex>
            <v-flex xs6 pl-3>
              <v-checkbox
                label="Artwork modified"
                v-model="userFormData.artwork_modified"
                color="black"
                hide-details
              ></v-checkbox>
            </v-flex>
            <v-flex xs6>
              <v-checkbox
                label="Artist modified"
                v-model="userFormData.artist_modified"
                color="black"
                hide-details
              ></v-checkbox>
            </v-flex>

            <v-flex
              style="background-color: #292929; color: #eee"
              class="px-3 py-1 my-2 mt-4 elevation-0 xs12"
            >
              <h3 class="font-weight-bold subtitle xs12 flex">
                Personal Settings
              </h3>
            </v-flex>

            <v-flex xs6 pl-3>
              <v-checkbox
                label="Expand Artist Artworks"
                v-model="userFormData.expand_artist_artworks"
                color="black"
                hide-details
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 pl-3 pt-3>
              <v-select
                :items="links"
                v-model="userFormData.after_login_page"
                label="Where to go after login?"
              ></v-select>
            </v-flex>

            <v-flex
              v-if="c_user.edit"
              style="background-color: #292929; color: #eee"
              class="px-3 py-1 my-2 mt-5 elevation-0 xs12"
            >
              <h3 class="font-weight-bold subtitle xs12 flex">
                Old CMS User Rights
              </h3>
            </v-flex>

            <v-flex xs12 v-if="c_user.edit">
              <div v-html="domains_to_string" class="px-3"></div>
            </v-flex>
            <!-- </v-layout> -->

            <!-- <v-flex xs12 px-4>
              <v-autocomplete
                v-model="userFormData.roles"
                item-text="title"
                item-value="id"
                :items="formatted_roles"
                deletable-chips
                chips
                color="grey"
                label="Choose user roles"
                multiple
              >
                <template slot="selection" slot-scope="data">
                  <v-chip
                    :selected="data.selected"
                    close
                    @input="remove(data.item.id)"
                    :class="`${data.item.color} lighten-4 full-width my-1`"
                  > -->
            <!-- class="chip--select-multi" -->
            <!-- {{ data.item.title }}
                  </v-chip>
                </template>

                <template slot="item" slot-scope="data">
                  <template v-if="typeof data.item !== 'object'">
                    <div class="pl-3">{{ data.selected }}</div>
                  </template>
                  <template v-else> -->
            <!-- <v-list-tile-avatar>
                        <v-checkbox v-model="selected" :color="data.item.color" hide-details class="mb-3"></v-checkbox>
                      </v-list-tile-avatar> -->
            <!-- `${data.item.color} lighten-5  -->
            <!-- <div
                      class="py-2 my-1"
                      style="border-bottom: 1px solid black; width:100%"
                    >
                      <div
                        v-if="userFormData.roles.includes(data.item.id)"
                        class="mx-3"
                      >
                        <v-icon color="black">check_box</v-icon>
                        <span class="px-4 py-1" style="color:black !important;">
                          {{ data.item.title }}
                          <span class="right" style="color:grey !important;">{{
                            data.item.description
                          }}</span>
                        </span>
                      </div>
                      <div v-else class="mx-3">
                        <v-icon color="black">check_box_outline_blank</v-icon>
                        <span class="px-4 py-1" style="color:black !important;">
                          {{ data.item.title }}
                          <span class="right" style="color:grey !important;">{{
                            data.item.description
                          }}</span>
                        </span>
                      </div>
                    </div>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex> -->
          </v-layout>

          <v-layout row wrap v-if="currentTab == 'History'">
            <template xs12 mb-4 mt-5>
              <template xs12 mb-4>
                <!-- <div class="headline mb-2 mx-1">Updates by this user</div> -->
                <v-flex
                  style="background-color: #292929; color: #eee"
                  class="px-2 py-1 my-4 elevation-0 xs12"
                >
                  <h3 class="font-weight-bold subtitle xs12 flex">
                    Updates by this user
                  </h3>
                </v-flex>

                <v-flex class="px-0 py-1 my-4 elevation-0 xs12">
                  <v-card-title>
                    <v-toolbar-title class="elevation-0 ml-3 pt-3 pb-0">
                      History of changes by this User
                    </v-toolbar-title>

                    <v-spacer></v-spacer>
                    <v-text-field
                      class="mr-3"
                      append-icon="search"
                      label="Search "
                      single-line
                      clearable
                      hide-details
                      v-model="search"
                    ></v-text-field>
                  </v-card-title>

                  <v-data-table
                    :search="search"
                    :headers="headers"
                    :items="user_journal"
                    item-key="id"
                    class="elevation-2 mx-4"
                    v-model="selected"
                    :pagination.sync="p"
                  >
                    <template slot="items" slot-scope="props">
                      <td
                        colspan="6"
                        style="
                          width: 100%;
                          padding: 0px;
                          margin: 0px;
                          height: 100px !important;
                        "
                      >
                        <v-layout row wrap class="mx-0">
                          <v-flex class="subheading py-3 pl-4 text-xs-left xs2">
                            <b class="title">{{
                              format_date(props.item.created_at)
                            }}</b
                            ><br />
                            <div
                              v-html="format_journal_artwork(props.item)"
                              class="body-1"
                            ></div>
                            in {{ props.item.cms.toUpperCase() }} CMS<br />
                            <span>{{
                              props.item.value_name.split('_').join(' ')
                            }}</span>
                          </v-flex>

                          <v-flex class="xs5">
                            <v-layout row wrap class="content pr-3">
                              <v-flex class="xs1 pt-2">
                                <v-btn
                                  class="ml-0 pl-0"
                                  :disabled="!props.item.old_value"
                                  icon
                                  small
                                  @click="viewText(props.item.old_value, 'Old')"
                                  ><v-icon
                                    :color="
                                      props.item.old_value ? 'black' : 'grey'
                                    "
                                    small
                                    >remove_red_eye</v-icon
                                  ></v-btn
                                ><br />
                                <v-btn
                                  v-if="c_user.edit"
                                  class="ml-0 pl-0"
                                  :disabled="!props.item.old_value"
                                  icon
                                  small
                                  @click="restoreValue(props.item, 'old_value')"
                                  ><v-icon color="black" small
                                    >settings_backup_restore</v-icon
                                  ></v-btn
                                >
                              </v-flex>
                              <v-flex xs11 py-3>
                                <span
                                  class="multi-line"
                                  v-html="
                                    props.item.old_value == null
                                      ? ' &nbsp; &nbsp; &nbsp; '
                                      : props.item.old_value
                                  "
                                ></span>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex class="xs5">
                            <v-layout row wrap class="content pr-3">
                              <v-flex class="xs1 pt-2">
                                <v-btn
                                  small
                                  class="ml-0 pl-0"
                                  :disabled="!props.item.new_value"
                                  icon
                                  @click="viewText(props.item.new_value, 'New')"
                                  ><v-icon
                                    :color="
                                      props.item.new_value ? 'black' : 'grey'
                                    "
                                    small
                                    >remove_red_eye</v-icon
                                  ></v-btn
                                ><br />
                                <v-btn
                                  class="ml-0 pl-0"
                                  :disabled="!props.item.new_value"
                                  icon
                                  small
                                  @click="restoreValue(props.item, 'new_value')"
                                  ><v-icon color="black" small
                                    >settings_backup_restore</v-icon
                                  ></v-btn
                                >
                              </v-flex>
                              <v-flex xs11 py-3>
                                <span
                                  class="multi-line"
                                  v-html="
                                    props.item.new_value == null
                                      ? ' &nbsp; &nbsp; &nbsp; '
                                      : props.item.new_value
                                  "
                                ></span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </td>
                    </template>

                    <template slot="no-data">
                      <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                      <center>No data available</center>
                    </template>
                  </v-data-table>
                </v-flex>

                <v-flex xs12 v-if="user_journal.length > 0">
                  <v-card
                    v-for="(item, index) in user_journal.slice(0, 130)"
                    :key="'j_' + item.id"
                    class="mx-1 py-2 xs12 elevation-0 pt-3"
                    style="border-top: 1px solid #ddd"
                    v-if="journals.length > 0"
                  >
                    <v-card-title class="title px-3 py-0">
                      <v-flex
                        >{{ format_date(item.created_at) }} |
                        {{ item.value_name }} changed</v-flex
                      >
                      <v-spacer></v-spacer>
                      <v-flex class="body-2 text-xs-right">
                        <v-list-tile-action-text>
                          In {{ item.cms }} CMS</v-list-tile-action-text
                        >
                      </v-flex>
                    </v-card-title>
                    <v-card-text>
                      <div
                        v-html="format_journal_artwork(item)"
                        class="body-1"
                      ></div>
                      <div
                        v-html="
                          '<b>OLD VALUE:</b> ' +
                          (item.old_value == null ? '' : item.old_value)
                        "
                        class="body-1 my-2"
                      ></div>
                      <div
                        v-html="'<b>NEW VALUE:</b> ' + item.new_value"
                        class="body-1"
                      ></div>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <!-- <v-icon v-if="item.user_id != c_user.id" color="grey lighten-1"> star_border </v-icon> -->
                <!-- <v-icon v-else color="yellow darken-2" > star </v-icon> -->

                <!--                 
                <v-list three-line v-if="user_journal.length > 0">
                  <template v-for="(item, index) in user_journal.slice(0,30)">
                    <v-list-tile :key="item.id" avatar ripple>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ format_date(item.created_at) }}</v-list-tile-title>
                        <v-list-tile-title
                          v-html="format_journal_artwork(item)"
                          class="text--primary"
                        ></v-list-tile-title>
                        <v-list-tile-sub-title v-html="format_journal_journal(item)"></v-list-tile-sub-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-list-tile-action-text>In {{item.cms}} CMS by {{format_journal_user(item)}}</v-list-tile-action-text>
                        <v-icon
                          v-if="item.user_id != userFormData.id"
                          color="grey lighten-1"
                        >star_border</v-icon>
                        <v-icon v-else color="yellow darken-2">star</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider v-if="index + 1 < user_journal.length" :key="index"></v-divider>
                  </template>
                </v-list> -->

                <!-- <div v-else class="subheading mt-4 ml-1">
                  No updates recorded for this user.
                </div> -->
              </template>
            </template>
          </v-layout>
        </v-container>
        <v-snackbar
          v-model="snackbar"
          right
          :timeout="2500"
          :color="snackbar_color"
          top
          >{{ snackbar_text }}</v-snackbar
        >
      </v-card>
    </v-form>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import constants from '@/data/constants'
import * as qs from 'querystring'
export default {
  props: ['user'],
  data() {
    return {
      constants: constants,
      dialogJpg: '',
      dialogImage: false,
      roles_array: [],
      search: '',
      headers: [
        { text: 'Date', align: 'left', sortable: true, value: 'created_at' },
        {
          text: 'CMS',
          align: 'left',
          sortable: true,
          value: 'cms',
        },
        {
          text: 'Changed by',
          align: 'left',
          value: 'created_by',
          sortable: true,
        },
        { text: 'Field', align: 'left ', sortable: true, value: 'value_name' },
        {
          text: 'Old value',
          align: 'left',
          value: 'old_value',
          sortable: true,
        },
        {
          text: 'New value',
          align: 'left',
          value: 'new_value',
          sortable: true,
        },
        // { text: "Actions", align: "right", sortable: false, align: "center" }
      ],
      p: {
        descending: true,
        rowsPerPage: 10,
        sortBy: 'created_at',
      },
      show3: true,
      journals: [],
      roles: [],
      snackbar: false,
      loading: false,
      snackbar_text: '',
      snackbar_color: 'black',
      selected: [],
      options: false,
      userFormData: Object.assign({}, this.user),
      editUser: false,
      result: '',
      currentTab: 'basic',
      valid: true,
    }
  },
  // watch: {
  //   userFormData: {
  //     handler: 'save',
  //     immediate: false,
  //     deep: true
  //     // console.log('new: %s, old: %s', val, oldVal)
  //   },
  // },
  beforeMount() {
    this.getUser()
    // console.log('this.$route.params')
    // console.log(this.$route.params)
    if (this.$route.params.user) {
      this.userFormData = Object.assign({}, this.$route.params.user)
      // console.log(this.$route.params.user)
    } else {
      // this.result = this.c_user;
      // this.userFormData = this.c_user;
      // this.user = this.c_user
      // console.log('this.user')
      // console.log(this.user)
    }
    // setTimeout(function () {
    // }.bind(this),4000)
    // this.userFormData = Object.assign({},this.result)
    this.setCurrentTab('Details')
    // this.df2 = Object.assign([],this.df)
    this.$store.dispatch('loadRoles')
  },
  mounted() {
    // this.df2 = Object.assign([],this.df)
    this.initialize()
    // this.$store.dispatch("loadJournals");
    // if (!this.user) {
    //   this.userFormData = this.c_user;
    // }
  },
  // mounted() {
  // this.df2 = Object.assign([],this.df)
  // },
  methods: {
    setAllCollections() {
      // console.log('setAllCollections')
      this.formatted_roles
        .filter((fr) =>
          [1, 17, 18, 19, 20, 21, 22, 31, 32, 40, 41, 43, 46].includes(fr.id)
        )
        .forEach((r) => {
          // console.log(r)
          this.roles_array.push(r.id)
          !this.roles_array.includes(r.id)
            ? this.userFormData.roles.push({ id: r.id, shortcut: r.shortcut })
            : {}
        })
    },
    showHelp(jpg) {
      this.dialogJpg = jpg
      this.dialogImage = !this.dialogImage
    },
    save() {
      this.loading = true
      // this.after_login_page = this.userFormData.after_login_page;
      // if (this.$refs.form.validate()) {
      // console.log(this.roles_array)
      let url = `${this.$globals.apiserver}/users/${this.userFormData.id}.json`
      // this.artistLink.artist_id = this.artistFormData.id
      if (this.userFormData.password == '') {
        delete this.userFormData.pw_clear
        delete this.userFormData.password
      } else {
        this.userFormData.pw_clear = this.userFormData.password
      }
      // this.userFormData.role_ids = this.userFormData.roles.map(r => r.id)
      this.userFormData.roles = this.roles_array
      this.userFormData.role_ids = this.roles_array
      // console.log(this.userFormData);
      delete this.userFormData.domains
      axios
        .put(url, {
          user: this.userFormData,
        })
        .then((response) => {
          this.snackbar_color = 'green'
          this.snackbar_text = 'User data saved.'
          this.$store.dispatch('loadUsers')
          this.snackbar = true
          // this.$store.dispatch("setCurrentUser", response.data);
          // this.$store.dispatch("updateUser", response.data);
          this.$store.dispatch('replaceObject', {
            item: { item: response.data, table: 'users' },
          })
          // this.userFormData = response.data
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.snackbar = true
          this.snackbar_color = 'red'
          this.snackbar_text =
            'Data not saved, please test your internet connection or contact developer.'
          // console.log(error)
        })
    },
    remove_role(item) {
      // console.log(item);
      const index = this.userFormData.roles.indexOf(item)
      if (index >= 0) this.userFormData.roles.splice(index, 1)
    },
    initialize() {
      // console.log(this.userFormData)
      this.roles_array = this.userFormData.roles.map((r) => r.id)
      this.roles = this.$store.state.roles
      // this.journals = this.$store.state.journals;
      this.getJournals()
    },
    remove_id(item) {
      // console.log(item)
      // console.log(this.userFormData.roles)
      const index = this.userFormData.roles.findIndex((r) => r.id === item)
      // console.log(index)
      if (index >= 0) this.userFormData.roles.splice(index, 1)
    },
    remove(item) {
      // console.log(item)
      // console.log(this.userFormData.roles)
      // console.log(this.formatted_roles)
      const index = this.userFormData.roles.findIndex((r) => r.id === item)
      // console.log(index)
      if (index >= 0) this.userFormData.roles.splice(index, 1)
      if (item == 2) {
        this.setAllCollections()
      }
    },
    format_date(date) {
      var moment = require('moment')
      var ndate = new Date(date)
      return moment(ndate).format('YYYY-MM-DD hh:mm')
    },
    format_journal_artwork(j) {
      var a = this.$store.state.artworks.find((a) => a.id == j.journaled_id)
      // var u = this.$store.state.users.find(u => u.id == j.user_id)
      // console.log(a);
      if (a) {
        return `${j.class_name}: <br />${a.title} [${a.full_name}]`
      } else {
        return ''
      }
    },
    format_journal_journal(j) {
      // var a = this.$store.state.artworks.find(a => a.id == j.journaled_id)
      // var u = this.$store.state.users.find(u => u.id == j.user_id)
      return `"${j.value_name}" changed from "${j.old_value}" to "${j.new_value}`
    },
    format_journal_user(j) {
      // var a = this.$store.state.artworks.find(a => a.id == j.journaled_id)
      if (j.user_id) {
        var u = this.$store.state.users.find((u) => u.id == j.user_id)
        return `${u.firstname} ${u.lastname}`
      } else {
        return 'unknown'
      }
    },
    getJournals() {
      setTimeout(() => {
        let url = `${this.$globals.apiserver}/journals/index_user/${this.userFormData.id}.json`
        axios
          .get(url)
          .then((response) => {
            this.journals = response.data
            // this.progress = false;
          })
          .catch((error) => {
            // console.log(error)
          })
      }, 1000)
    },
    // loadRoles() {
    //   this.roles = Object.assign([],this.$store.state.roles)
    //   return this.roles
    // },
    formatDate(date) {
      date = new Date(date)
      var monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ]

      var day = date.getDate()
      var monthIndex = date.getMonth()
      var year = date.getFullYear()

      return day + ' ' + monthNames[monthIndex] + ' ' + year
    },
    addToSelection(a) {
      // console.log('a = ' + a)
      // setTimeout(function () {
      var tempSelection = Object.assign([], this.$store.state.currentSelection)
      // console.log(tempSelection)
      // if (!a) {
      // console.log('a true')
      if (!tempSelection.includes(a)) {
        // console.log('doesnt include')
        tempSelection.push(a)
      }
      // } else {
      // console.log('false')
      // var index = tempSelection.indexOf(a);
      // console.log('index = ' + index)
      // tempSelection.splice(index,1)
      // }
      // this.$store.state.currentSelection
      // console.log(tempSelection)
      // this.selected.forEach(s => {
      //   if (!tempSelection.includes(s)) {
      //     tempSelection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', tempSelection)
      // }.bind(this),1000)
    },
    setCurrentTab(tab) {
      // console.log(tab)
      // console.log(this.fields.tabs['basic'])
      // console.log(this.field_list)
      // this.currentFields = this.fields.tabs[tab].fields
      // console.log(this.fields.tabs)
      // if (!this.currentFields) {
      //   this.currentFields = this.fields.tabs[tab]
      // }
      // console.log(this.currentFields)
      // this.saveCurrentTab (tab)
      this.currentTab = tab
    },
    // saveCurrentTab (tab) {
    //   // setTimeout(function () {
    //     this.$store.dispatch("saveCurrentTab", tab)
    //   // }.bind(this),1000)
    // },
    getUser() {
      let url = `${this.$globals.apiserver}/users/${this.$route.params.id}.json`
      axios
        .get(url)
        .then((response) => {
          // this.loading = false;
          this.result = Object.assign({}, response.data)
          this.userFormData = response.data
        })
        .catch((error) => {
          // console.log(error)
        })
    },
    clear() {
      this.$refs.form.reset()
    },
    submit() {
      const art = this.userFormData
      const requestConfig = {
        url: `${this.$globals.apiserver}/users/api_update/${this.$route.params.id}`,
        method: 'POST',
        data: qs.stringify(art),
      }
      const response = axios.request(requestConfig)
    },
  },
  computed: {
    links() {
      var o = this.constants.OWNERSHIPS
      var out = Object.keys(o)
        .map((e) => o[e].name)
        .concat(['Artists', 'Contacts'])
      out.push('Lists')
      return out
    },
    // c_user () {
    //   return this.$store.state.user.profile
    // },
    user_journal() {
      var js = this.journals.filter((j) => j.user_id == this.userFormData.id)
      return js
    },
    formatted_roles() {
      var rs = Object.assign([], this.roles)
      var newrs = []
      rs.sort((a, b) => a.group < b.group)
      // console.log(rs)
      let group = ''

      rs.forEach((val) => {
        if (group != val.group) {
          // newrs.push({ divider: true });
          newrs.push({ header: val.group, image: val.image })
        }
        newrs.push(val)
        group = val.group
      })
      // console.log(newrs);
      return newrs
    },
    domains_to_string() {
      if (this.result.domains) {
        return this.result.domains.replace(/ /g, '<br />')
      }
    },
    options_c: {
      get() {
        return this.$store.state.options
      },
      set(value) {
        this.$store.dispatch('saveOptions', value)
      },
    },
    // currentTabShown () {
    //   console.log('currentTabShown')
    //   console.log(this.currentTab)
    //   console.log(fields.tabs[this.currentTab])
    //   return fields.tabs[this.currentTab]
    // },
    processedUser() {
      // console.log('processedUser')
      var artwork = this.result
      if (artwork && artwork.artwork_photos) {
        artwork.keywords = []
        for (var ap in artwork.artwork_photos) {
          if (artwork.artwork_photos[ap].keywords) {
            try {
              artwork.artwork_photos[ap].keywords = JSON.parse(
                artwork.artwork_photos[ap].keywords
              ).map((k) => (k = k.toString()))
            } catch (err) {
              // console.log('error while parsing keywords')
            }
          } else {
            artwork.artwork_photos[ap].keywords = []
          }
          artwork.keywords = artwork.keywords.concat(
            artwork.artwork_photos[ap].keywords.map((k) => (k = k.toString()))
          )
        }
      }
      if (artwork && artwork.keywords) {
        artwork.keywords = [...new Set(artwork.keywords)]
        artwork.keywords = artwork.keywords.sort(function (a, b) {
          return a.toUpperCase().localeCompare(b.toUpperCase())
        })
      }
      return artwork
    },
  },
}
</script>

<style scoped>
small {
  font-size: 16px;
}
.bright {
  border-right: solid 1px black;
}
.bleft {
  border-left: solid 1px black;
}
.v-list__tile
  v-list__tile--link
  v-list__tile--active
  theme--light
  primary--text {
  text-decoration: underline !important;
  font-size: 5px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/users/EditUser.vue